import { Header, HText, Paragraph, Footer } from "../components"; // Added Footer
import styles from "./About.module.css";
import profilePic from "../assets/images/mauro/mauro-van-name.jpg";
import hydrogenIcon from "../assets/icons/eco.svg";
import electricalIcon from "../assets/icons/electric.svg";
import mechanicalIcon from "../assets/icons/engine.svg";
import airConditioningIcon from "../assets/icons/airconditioning.svg";

export const About = () => {
  return (
    <div className={styles.bodyMain}>
      <Header linksStyle="" />
      <div className={styles.main}>
        <div className={styles.aboutIntro}>
          <img
            src={profilePic}
            className={styles.profileImage}
            alt="Profile of Mauro"
          />
          <div>
            <HText text={"About Massari Auto Service"} />
            <Paragraph
              text={`Welcome to Massari Auto Service, your comprehensive automotive care center! We offer a wide range of services including our signature Hydrogen Engine Cleaning, electrical repairs, light mechanical work, and air-conditioning servicing. Led by Mauro Massari, a certified Heavy Duty Diesel Mechanic and Auto Electrician, we're committed to providing quality service for all your automotive needs.`}
            />
          </div>
        </div>

        <Paragraph
          text={`Our team combines years of experience with the latest diagnostic tools to deliver efficient and reliable service. Whether you need electrical troubleshooting, mechanical repairs, air-conditioning maintenance, or our eco-friendly hydrogen engine cleaning, we have the expertise to keep your vehicle in optimal condition.`}
        />

        {/* TODO: Optional: Add "Our Mission/Values" section */}
        {/*
                <div className={styles.missionSection}>
                    <HText text="Our Mission & Values" />
                    <Paragraph text="Placeholder: Briefly state your business mission (e.g., 'To provide reliable, high-quality, and honest automotive services to our community.')" />
                    <ul>
                        <li><Paragraph text="Value 1: e.g., Integrity & Honesty" /></li>
                        <li><Paragraph text="Value 2: e.g., Quality Workmanship" /></li>
                        <li><Paragraph text="Value 3: e.g., Customer Satisfaction" /></li>
                    </ul>
                </div>
                */}

        <div className={styles.serviceDetail}>
          <img
            src={hydrogenIcon}
            alt="Hydrogen Cleaning Icon"
            className={styles.serviceIcon}
          />
          <div>
            <HText text={"Hydrogen Engine Cleaning"} />
            <Paragraph
              text={`Our signature service utilizes our patented Hydrogen Generator to create active Hydrogen gas on-demand, cleaning combustion engines without harmful chemicals. This eco-friendly process removes carbon deposits, increases engine performance, improves fuel efficiency, and reduces emissions. It's just one of the many ways we combine traditional automotive services with innovative, environmentally conscious solutions.`}
            />
          </div>
        </div>
        <div className={styles.serviceDetail}>
          <img
            src={electricalIcon}
            alt="Electrical Icon"
            className={styles.serviceIcon}
          />
          <div>
            <HText text={"Professional Electrical Services"} />
            <Paragraph
              text={
                "Our electrical services cover everything from battery and alternator testing to complex electrical system diagnostics and repairs. We handle starter motor issues, lighting problems, electrical component replacements, and complete wiring solutions to ensure your vehicle's electrical systems function reliably."
              }
            />
          </div>
        </div>

        <div className={styles.serviceDetail}>
          <img
            src={mechanicalIcon}
            alt="Mechanical Repairs Icon"
            className={styles.serviceIcon}
          />
          <div>
            <HText text={"Light Mechanical Repairs"} />
            <Paragraph
              text={`Our mechanical services include fluid checks and replacements, brake system maintenance, filter changes, basic engine repairs, suspension checks, and general vehicle maintenance. We provide thorough inspections and honest assessments to keep your vehicle running smoothly and safely.`}
            />
          </div>
        </div>

        <div className={styles.serviceDetail}>
          <img
            src={airConditioningIcon}
            alt="Air Conditioning Icon"
            className={styles.serviceIcon}
          />
          <div>
            <HText text={"Air Conditioning Maintenance"} />
            <Paragraph
              text={`We provide complete air conditioning services including system performance checks, refrigerant level assessments, leak detection and repair, component replacement, and regular maintenance. Our goal is to ensure your vehicle's climate control system keeps you comfortable in all weather conditions.`}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
